import { includes } from 'ramda'
import { BOUNDS_DBAS_RESULTS } from '../const/dbas'
import { findKey } from './object'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const getRangeDbas = (result) =>
  findKey((key, value) => includes(result, value), BOUNDS_DBAS_RESULTS)
